var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.bus.code != 83001003)?_c('div',{staticClass:"empty"},[_c('btn',{attrs:{"type":"primary","type":0,"info":"去登录"},on:{"click":_vm.gotoLogin}})],1):_c('div',{staticClass:"noPermission"},[_vm._v("该账号不是小程序企业，无管理权限")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c52734b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccessDeny.vue
// module id = null
// module chunks = 